import jellyTriangle from '../elements/jellyTriangle.js';
jellyTriangle.register();
